import { IconButton } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import { usePageContext } from "@ryde/redux";
import { tableSettingsDrawerAF, TOOLTIP_DELAY_BUTTONS } from "@ryde/shared";

export const ReportTableHeadSettings: FC = () => {
  const { entity } = usePageContext();
  const { t } = useTranslation();
  const setReportTableLayoutDrawerState = useSetRecoilState(
    tableSettingsDrawerAF(entity),
  );
  return (
    <div data-e2e="report-open-table-settings">
      <IconButton onClick={() => setReportTableLayoutDrawerState(true)}>
        <FramerTooltip
          content={t("general.OPEN_SETTINGS")}
          mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
        >
          <SVG_MUI.ReportsSettingsDrawerSVG className="pointer open-settings-icon" />
        </FramerTooltip>
      </IconButton>
    </div>
  );
};
